import React from "react";
import projectImage1 from "../assets/images/project/project1.png";
import projectImage2 from "../assets/images/project/project2.png";
import styled from "styled-components";

//Icons
import { GoLinkExternal } from "react-icons/go";
import reactLogo from "../assets/skills/react.png";
import styledComponentsLogo from "../assets/skills/styled-components.png";
import gsapLogo from "../assets/skills/gsap.png";
import framerLogo from "../assets/skills/framer-motion.webp";
import sanity from "../assets/skills/sanity.png";
import nextjs from "../assets/skills/next-js.png";
import stripe from "../assets/skills/stripe.png";

const CardProject = () => {

  return (
    <CardSection>
      <div className="all-items">
        <div className="item">
          <div className="left">
            <div className="img">
              <img className="project-img" src={projectImage1} alt="project1" />
            </div>
          </div>
          <div className="right">
            <h2 className="project-title">Fashion Studio</h2>
            <p className="project-desc">
              Réalisation d'une application web e-commerce de mode avec des technologies modernes.
            </p>
            <div className="logo-skills">
              <img title="Logo React" src={reactLogo} alt="Logo React" />
              <img
                title="Logo Styled Components"
                src={styledComponentsLogo}
                alt="Logo Styled Components"
              />
              <img title="Logo GreenSock" src={gsapLogo} alt="Logo GreenSock" />
              <img title="Logo Framer-Motion" src={framerLogo} alt="Logo Framer-Motion" />
            </div>

            <div className="buttons">
              <a
                href="https://vasco-studio.vercel.app"
                target="_blank"
                className="primary-btn outline external-link"
              >
                <span>
                  Accéder au site
                  <GoLinkExternal size={20} />
                </span>
              </a>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="left">
            <div className="img">
              <img className="project-img" src={projectImage2} alt="project1" />
            </div>
          </div>
          <div className="right">
            <h2 className="project-title">Vasco Shop</h2>

            <p className="project-desc">
              Réalisation d'une application web e-commerce Full-Stack.
            </p>
            <div className="logo-skills">
              <img title="Logo React" src={reactLogo} alt="Logo React" />
              <img title="Logo NextJS" src={nextjs} alt="Logo NextJs" />
              <img title="Logo Sanity" src={sanity} alt="Logo Sanity" />
              <img title="Logo Stripe" src={stripe} alt="Logo Stripe" />
            </div>
            <div className="buttons">
              <a
                href="https://e-commerce-sanity-stripe-vascob-77.vercel.app/"
                target="_blank"
                className="primary-btn outline external-link"
              >
                <span>
                  Accéder au site
                  <GoLinkExternal size={20} />
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </CardSection>
  );
};

export default CardProject;

const CardSection = styled.div`
  width: 80%;
  margin: 0 auto;

  .logo-skills {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 20px;
  }

  .logo-skills > img {
    width: 45px;
  }

  .item {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 800px;
    margin: 2rem auto 0 auto;
  }

  .item:nth-child(even) {
    flex-direction: row-reverse;
    margin-top: 8rem;
  }

  .item .left {
    flex: 1;
  }

  .item .right {
    flex: 1;
    min-width: 250px;
    max-width: 300px;
    margin-left: -150px;
    padding: 3rem 2rem;
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 0 7px #000020;
    z-index: 11;
  }

  .item:nth-child(even) .right {
    margin-left: 0;
  }

  .item:nth-child(even) .left {
    margin-left: -150px;
  }

  .item .left .img {
    position: relative;
    overflow: hidden;
    border-radius: 12px;
    box-shadow: 0px 0px 20px #4705fc33;
    object-fit: cover;
  }

  .item .left .project-img {
    width: 100%;
    max-height: 500px;
    object-fit: cover;
    object-position: center;
    transition: 0.3s ease transform;
  }

  .item .left .img::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(136, 144, 163, 0.22);
  }

  .item:hover .left .img img {
    transform: scale(1.1);
    z-index: 1;
  }

  .item .right .project-title {
    font-size: ${(props) => props.theme.fontmd};
    font-family: "Poppins", sans-serif;
    margin-bottom: 2rem;
  }

  .item .right .project-desc {
    color: grey;
    margin-bottom: 3rem;
  }

  .item .right .buttons .external-link {
    display: flex;
    justify-content: center;
    align-content: center;
    gap: 1rem;
    padding: calc(1em - 14px) calc(1.6em - 4px);
  }

  a {
    text-decoration: none;
  }

  a > span {
    background-color: black;
    color: white;
    padding: 0.5rem 0.8rem;
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Poppins";
    gap: 4px;
  }

  @media only screen and (max-width: 1024px) {
    .item {
      flex-direction: column;
      margin-bottom: 50px;
      overflow-x: visible;
    }

    .item .project-img {
      width: 100%;
    }

    .item .left {
      width: 100%;
    }

    .item .right {
      width: 90%;
      margin-left: 0;
      margin-top: -150px;
    }

    .item:nth-child(even) {
      flex-direction: column;
    }

    .item:nth-child(even) .left {
      margin-left: 0;
    }
  }

  @media only screen and (max-width: 768px) {
    .logo-skills > img {
      width: 33px;
    }
  }
`;
